import { colors, StyledIcon } from 'fitify-ui'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledButton = styled.button<{
  $isActive?: boolean
  $variant?: 'button' | 'circle'
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 16px;
  border-radius: 100px;
  cursor: pointer;
  gap: 6px;
  transition: all 100ms ease-in-out;

  ${({ $variant }) => {
    if ($variant === 'circle') {
      return css`
        width: 40px;
        height: 40px;
        justify-content: center;
        border-radius: 50%;

        ${phone(css`
          width: 36px;
          height: 36px;
        `)}
      `
    }

    return css`
      padding: 8px 16px;
      border-radius: 100px;
    `
  }};

  ${({ $isActive }) =>
    $isActive
      ? css`
          border: 1px solid ${colors.Blue400};
          background-color: ${colors.Blue400};
          color: ${colors.White};
        `
      : css`
          border: 1px solid ${colors.Gray200};
          background-color: ${colors.White};
          color: ${colors.Gray700};

          &:hover {
            border-color: ${colors.Blue200};
            background-color: ${colors.Blue50};
          }
        `};

  ${StyledIcon} {
    width: 16px;
    height: 16px;
    color: inherit;
  }
`
